import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import SEOAuditTool from '@/components/seo/SEOAuditTool';
import SitemapGenerator from '@/components/admin/SitemapGenerator';
import SEOMonitoringDashboard from '@/components/seo/SEOMonitoringDashboard';
import SEOMonitoringConfig from '@/components/seo/SEOMonitoringConfig';
import SchemaValidator from '@/components/seo/SchemaValidator';
import SEO from '@/components/SEO';
import SEOReportsPanel from '@/components/seo/SEOReportsPanel';
import LinkAnalyzer from '@/components/seo/LinkAnalyzer';
import ContentDepthOptimizer from '@/components/seo/ContentDepthOptimizer';
import SEOHealthCheck from '@/components/seo/SEOHealthCheck';

export default function AdminSEO() {
  return (
    <div className="space-y-6">
      <SEO
        title="SEO Management"
        description="SeniorThrive SEO tools: audits, monitoring, schema validation, and sitemaps."
        noindex
      />
      <div>
        <h1 className="text-3xl font-bold">SEO Management</h1>
        <p className="text-muted-foreground">Comprehensive SEO tools and analysis for SeniorThrive</p>
      </div>

      <Tabs defaultValue="health" className="space-y-6">
        <TabsList className="grid w-full grid-cols-9">
          <TabsTrigger value="health">Health Check</TabsTrigger>
          <TabsTrigger value="audit">SEO Audit</TabsTrigger>
          <TabsTrigger value="sitemap">Sitemap</TabsTrigger>
          <TabsTrigger value="monitoring">Monitoring</TabsTrigger>
          <TabsTrigger value="config">Configuration</TabsTrigger>
          <TabsTrigger value="schema">Schema</TabsTrigger>
          <TabsTrigger value="reports">Reports</TabsTrigger>
          <TabsTrigger value="links">Links</TabsTrigger>
          <TabsTrigger value="content">Content</TabsTrigger>
        </TabsList>

        <TabsContent value="health" className="space-y-6">
          <SEOHealthCheck />
        </TabsContent>

        <TabsContent value="audit" className="space-y-6">
          <SEOAuditTool />
        </TabsContent>

        <TabsContent value="sitemap" className="space-y-6">
          <SitemapGenerator />
        </TabsContent>

          <TabsContent value="monitoring" className="space-y-6">
            <SEOMonitoringDashboard />
          </TabsContent>

          <TabsContent value="config" className="space-y-6">
            <SEOMonitoringConfig />
          </TabsContent>

        <TabsContent value="schema" className="space-y-6">
          <SchemaValidator />
        </TabsContent>

        <TabsContent value="reports" className="space-y-6">
          <SEOReportsPanel />
        </TabsContent>

        <TabsContent value="links" className="space-y-6">
          <LinkAnalyzer />
        </TabsContent>

        <TabsContent value="content" className="space-y-6">
          <ContentDepthOptimizer />
        </TabsContent>
      </Tabs>
    </div>
  );
}